import { t } from "@lingui/macro";
import React from "react";
import { Path, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const GiftCardIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Gift Card`} {...props}>
    <G clipPath="url(#a)">
      <Path
        fill="currentColor"
        d="M10.459 7.5a1.252 1.252 0 0 1 2.082 0l.094.17.638 1.387 1.519.18c.993.118 1.429 1.276.834 2.017l-.133.143-1.122 1.036.298 1.499c.195.98-.772 1.752-1.66 1.416l-.176-.082-1.333-.747-1.333.747c-.93.52-2.043-.288-1.836-1.334l.297-1.5-1.121-1.036c-.783-.724-.358-2.033.701-2.159l1.518-.18.64-1.387.093-.17ZM13.5 2.25a2.25 2.25 0 0 1 2.25 2.25V7a.75.75 0 0 1-1.5 0V4.5a.75.75 0 0 0-.75-.75h-11a.75.75 0 0 0-.75.75v7c0 .414.336.75.75.75h3a.75.75 0 0 1 0 1.5h-3A2.25 2.25 0 0 1 .25 11.5v-7A2.25 2.25 0 0 1 2.5 2.25h11Zm-2.472 7.563a1.25 1.25 0 0 1-.829.688l-.158.03-1.118.131.826.765.111.117c.24.288.341.67.267 1.044l-.22 1.104.983-.55.145-.07c.298-.12.632-.12.93 0l.145.07.982.55-.219-1.104a1.25 1.25 0 0 1 .378-1.161l.825-.765-1.117-.132a1.25 1.25 0 0 1-.91-.575l-.077-.143L11.5 8.79l-.472 1.024Zm-2.95-3.56a.75.75 0 0 1 0 1.493L8 7.75H4a.75.75 0 0 1 0-1.5h4l.077.004Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
